import { useState, useEffect } from 'react';

const DepthDistributionDiagram = ({ coverageData,setShowGeneCoverageSummaryModal }) => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);



    useEffect(() => {
        if (coverageData.length > 0) {
            const calculatedStats = calculateStats();
            setStats(calculatedStats);
        }
    }, [coverageData]);

    const calculateStats = () => {
        if (!coverageData.length) return null;

        const totalGenes = coverageData.length;
        const sortedMeanDepths = [...coverageData].sort((a, b) => a.meanDepth - b.meanDepth);
        const q1Index = Math.floor(coverageData.length * 0.25);
        const q3Index = Math.floor(coverageData.length * 0.75);

        const roundToNiceNumber = (num) => {
            const magnitude = Math.pow(10, Math.floor(Math.log10(num)));
            const normalized = num / magnitude;
            if (normalized < 1.5) return Math.round(1 * magnitude);
            if (normalized < 3.5) return Math.round(2.5 * magnitude);
            if (normalized < 7.5) return Math.round(5 * magnitude);
            return Math.round(10 * magnitude);
        };

        const lowThreshold = roundToNiceNumber(sortedMeanDepths[q1Index].meanDepth);
        const highThreshold = roundToNiceNumber(sortedMeanDepths[q3Index].meanDepth);

        const lowDepthGenes = coverageData.filter(gene => gene.meanDepth < lowThreshold).length;
        const mediumDepthGenes = coverageData.filter(gene => gene.meanDepth >= lowThreshold && gene.meanDepth < highThreshold).length;
        const highDepthGenes = coverageData.filter(gene => gene.meanDepth >= highThreshold).length;

        return {
            totalGenes,
            depthThresholds: {
                lowThreshold,
                highThreshold
            },
            depthCategories: {
                lowDepthGenes,
                mediumDepthGenes,
                highDepthGenes
            }
        };
    };

    if (loading || !stats) return <div className="text-center p-4">Loading...</div>;

    return (
        <div className=" mt-2 w-100" >
            <div className="">
                <div className="d-flex align-items-center my-1">
                    <h5 className="mb-0 fs-9 text-primary ">Read Depth Distribution</h5>
                    <div className="position-relative ms-2">
                        <button
                            type="button"
                            className="btn btn-sm btn-secondary rounded-circle px-2 py-0"
                            onClick={() => setShowTooltip(!showTooltip)}
                            onMouseEnter={() => setShowTooltip(true)}
                            onMouseLeave={() => setShowTooltip(false)}
                            style={{ fontSize: '0.50rem', width: '16px', height: '16px' }}
                        >
                            ?
                        </button>
                        {showTooltip && (
                            <div className="position-absolute bg-white border p-2 mt-1 shadow-sm" style={{ left: '120%', zIndex: 10, width: '250px', fontSize: '0.75rem' }}>
                                Thresholds are calculated based on the 25th and 75th percentiles of the gene depth distribution and rounded to meaningful values.
                            </div>
                        )}
                    </div>
                </div>
                <div className="d-flex gap-5 align-items-start">
                    <div className='w-100'>
                        <div className="d-flex justify-content-center mb-2" style={{ height: '40px' }}>
                            <div className="d-flex w-100">
                                {/* Low depth */}
                                <div
                                    className="   text-white fs-9 d-flex align-items-center justify-content-center rounded-start"
                                    style={{ width: `${(stats.depthCategories.lowDepthGenes / stats.totalGenes) * 100}%`, minWidth: '20px', backgroundColor: '#B2D7FF' }}
                                >
                                    {stats.depthCategories.lowDepthGenes > 0 ? stats.depthCategories.lowDepthGenes : ''}
                                </div>

                                {/* Medium depth */}
                                <div
                                    className=" text-white fs-9 d-flex align-items-center justify-content-center"
                                    style={{ width: `${(stats.depthCategories.mediumDepthGenes / stats.totalGenes) * 100}%`, minWidth: '20px', backgroundColor: '#439EFF' }}
                                >
                                    {stats.depthCategories.mediumDepthGenes > 0 ? stats.depthCategories.mediumDepthGenes : ''}
                                </div>

                                {/* High depth */}
                                <div
                                    className=" text-white fs-9 d-flex align-items-center justify-content-center rounded-end"
                                    style={{ width: `${(stats.depthCategories.highDepthGenes / stats.totalGenes) * 100}%`, minWidth: '20px', backgroundColor: '#0369A1' }}
                                >
                                    {stats.depthCategories.highDepthGenes > 0 ? stats.depthCategories.highDepthGenes : ''}
                                </div>
                            </div>


                        </div>

                        <div className="d-flex justify-content-between fs-10 text-muted">
                            <span>Low (&lt;{stats.depthThresholds.lowThreshold})</span>
                            <span>Medium ({stats.depthThresholds.lowThreshold}-{stats.depthThresholds.highThreshold})</span>
                            <span>High (&gt;{stats.depthThresholds.highThreshold})</span>
                        </div>

                    </div>
                    <button
                        type='button'
                        className='btn btn-primary btn-sm pull-right   fs-9 ms-auto'
                        onClick={() => {
                            setShowGeneCoverageSummaryModal(true);
                        }}
                    >
                        By Genes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DepthDistributionDiagram;
